import React from "react";
import { sanitiseString } from "../../Utils";

import { SkipToContent } from "../SkipToContent";

export interface ListItem {
  id: string;
  text: string;
  url: string;
  target?: string;
  dataTestId: string;
}

export interface Props {
  id: string;
  title: string;
  ariaLabel?: string;
  skipLink?: { url: string; text: string };
  itemsList: ListItem[];
  dataTestId: string;
}

export const TableOfContents = (props: Props) => {
  const sanitisedId = sanitiseString(props.id);
  const sanitisedDataTestId = sanitiseString(props.dataTestId);
  return (
    <aside
      className="ons-toc-container"
      role="complementary"
      id={sanitisedId}
      data-testid={sanitisedDataTestId}
    >
      {props.skipLink && (
        <SkipToContent
          url={props.skipLink.url}
          text={props.skipLink.text}
          id={`${sanitisedId}-skiplink`}
          dataTestId={`${sanitisedDataTestId}-skiplink`}
        />
      )}
      <nav
        className="ons-toc"
        aria-label={props.ariaLabel || "Table of contents"}
        data-testid={`nav-${sanitisedDataTestId}`}
      >
        <h2 className="ons-toc__title ons-u-fs-r--b ons-u-mb-s">
          {props.title}
        </h2>
        <ul
          className="ons-list ons-u-mb-m ons-list--dashed"
          data-testid={`list-${sanitisedDataTestId}`}
        >
          {props.itemsList.map((item, index) => (
            <li key={index} className="ons-list__item">
              <a
                href={item.url}
                {...(item.target ? { target: item.target } : {})}
              >
                {item.text}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};
